import { ApiBaseService, setAuthHeader, unsetAuthHeader } from './api-base.service'

const LOGIN_ENDPOINT = '/auth/login';
const REGISTER_ENDPOINT = '/auth/register';
const PROFILE_ENDPOINT = '/auth/me';

class AuthApiService {
  login(email, password) {
    return ApiBaseService.post(
      LOGIN_ENDPOINT,
      { email, password }
    ).then(({ data }) => {
      setAuthHeader(data.accessToken);
      localStorage.setItem('token', data.accessToken);
      return data;
    });
  }

  register(registrationData) {
    return ApiBaseService.post(
      REGISTER_ENDPOINT,
      registrationData
    ).then(({ data }) => {
      setAuthHeader(data.accessToken);
      localStorage.setItem('token', data.accessToken);
      return data;
    });
  }

  getUser() {
    return ApiBaseService.get(
      PROFILE_ENDPOINT
    ).then(({ data }) => data)
    .catch(() => localStorage.removeItem('token'));
  }

  logout() {
    localStorage.removeItem('token');
    unsetAuthHeader();
  }
}
let authApiService = new AuthApiService;
export { authApiService as AuthApiService };
